<script lang="ts" setup>
const logos = [
  { name: 'Newsweek', src: '/images/press/newsweek.svg' },
  { name: 'CoinDesk', src: '/images/press/coindesk.svg' },
  { name: 'Cointelegraph', src: '/images/press/cointelegraph.svg' },
  { name: 'BeInCrypto', src: '/images/press/beincrypto.svg' },
  { name: 'Finance Magnates', src: '/images/press/finance-magnates.svg' },
  { name: 'CCN', src: '/images/press/ccn.svg' },
  { name: 'Decrypt', src: '/images/press/decrypt.svg' },
  { name: 'crypto.news', src: '/images/press/crypto-news.svg' },
]
</script>

<template>
  <section data-el="CorePressStrip" class="flex flex-col gap-6 md:flex-row md:items-center md:gap-10">
    <span class="shrink-0 font-mono text-[13px] font-medium leading-4 tracking-[-0.2px] text-secondary">
      As featured and commented on
    </span>
    <div class="flex flex-1 flex-wrap items-center justify-between gap-x-6 gap-y-5">
      <img
        v-for="logo in logos"
        :key="logo.name"
        :src="logo.src"
        :alt="logo.name"
        class="h-6 w-auto shrink-0 object-contain"
      >
    </div>
  </section>
</template>
